import { Input } from '@eliadmin/core/src/components/ui/input';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { Slider } from '@eliadmin/core/src/components/ui/slider';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useEffect, useState } from 'react';

type RangeFilterProps = {
  title?: string;
  value: number[];
  min: number;
  max: number;
  onValueChange: (value: number[]) => void;
  formatValue?: (value: number) => string;
  disabled?: boolean;
  templateSetting?: {
    enabled?: boolean;
    order?: number;
  };
  currency?: string;
};

export const RangeFilter = ({
  title,
  value,
  min,
  max,
  onValueChange,
  formatValue = v => v.toString(),
  disabled = true,
  templateSetting,
  currency,
}: RangeFilterProps) => {
  const [range, setRange] = useState<number[]>([value[0], value[1]]);

  useEffect(() => {
    setRange([value[0] ?? min, value[1] ?? max]);
  }, [value, min, max]);

  const handleRangeChange = () => {
    onValueChange(range);
  };

  const displayValue = (price: number) => {
    return formatValue(price) + (currency ? ` ${currency}` : '');
  };

  if (templateSetting && !templateSetting.enabled) {
    return null;
  }

  return (
    <div className={cn('flex flex-col items-start justify-start gap-4', '')}>
      <div className={cn('flex w-full flex-col gap-2 py-2', 'ea-attribute-range')}>
        {title && <h2 className="w-full text-start text-lg font-bold">{title}</h2>}
        <div className="flex flex-col gap-4">
          <div
            className={cn(
              'flex w-full flex-row justify-between gap-2',
              'ea-attribute-range__wrapper',
            )}
          >
            <Input
              aria-label={title ? `${title} – minimum` : 'Minimálny plat'}
              className={{ wrapper: cn('flex-1', 'ea-attribute-radio__input-min') }}
              name={'min'}
              variant={'outlined'}
              value={displayValue(range[0])}
              disabled={disabled}
            />
            <Input
              aria-label={title ? `${title} – maximum` : 'Maximálny plat'}
              className={{ wrapper: cn('flex-1', 'ea-attribute-radio__input-max') }}
              name={'max'}
              variant={'outlined'}
              value={displayValue(range[1])}
              disabled={disabled}
            />
          </div>
          <Slider
            isDual
            value={range}
            min={min}
            max={max}
            aria-label={`${title || 'Plat'} range`}
            onValueChange={value => setRange(value)}
            onBlur={handleRangeChange}
            className=""
          />
        </div>
      </div>
    </div>
  );
};
